const f = new Intl.NumberFormat(navigator.language, {
  style: 'decimal',
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

export function formatBytes(bytes: number): string {
  const sizes = ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const k = 1024;
  const i = Math.max(Math.floor(Math.log(bytes) / Math.log(k)), 1);
  const size = bytes / Math.pow(k, i);

  return `${f.format(size)} ${sizes[i - 1]}`;
}
